import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateUserMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userParams }) => {
      const response = await axios.post('/users/creations', {
        user: userParams,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.resetQueries(['importablePersonnel']);
    },
  });
}

export function useUpdateUserMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, userParams }) => {
      const response = await axios.patch(`/users/${id}`, {
        user: userParams,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.resetQueries(['importablePersonnel']);
    },
  });
}

export function useRestoreUserMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, userParams }) => {
      const response = await axios.post(`/users/${id}/restoration`, {
        restoration: { user_attributes: userParams },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.resetQueries(['importablePersonnel']);
    },
  });
}

export function useDestroyUserMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/users/${id}`);

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['accountUserAllowance']);
      queryClient.invalidateQueries(['users']);
      queryClient.resetQueries(['importablePersonnel']);
    },
  });
}
